
  <div [hidden]="!visible" [ngClass]="baseClass">
      <div *ngFor="let item of items; let i = index" [ngClass]="childClass + (i+1)" [style.backgroundColor]="color"></div>
  </div>



// WEBPACK FOOTER //
// ./node_modules/ng-spin-kit/dist/spinner/three-bounce.component.d.ts.ThreeBounceComponent.html